import _ from 'lodash';
import { CustomRenderers } from 'pages/ListManagement/types';

export const NumberRenderer = ({ allowEmpty, ...props }: CustomRenderers) => {
    const { value } = props;

    if (allowEmpty && value === '') props.TD.className = '';
    else if (value === '' || !_.isFinite(Number(value))) props.TD.className = 'htInvalid';
    else props.TD.className = '';

    return <div>{props.value}</div>;
};

export const AutoCompleteRenderer = ({ list, allowEmpty, ...props }: CustomRenderers) => {
    const { value } = props;

    if (allowEmpty && value === '') props.TD.className = '';
    else if (list) props.TD.className = list.includes(value as string) ? '' : 'htInvalid';

    return <div>{props.value}</div>;
};

export const CustomIntervalRenderer = ({ allowEmpty, ...props }: CustomRenderers) => {
    const { value } = props;
    const min = props.min;
    const max = props.max;
    const numericValue = Number(value);

    if (allowEmpty && value === '') props.TD.className = '';
    else if (value === '' || value == null) {
        props.TD.className = 'htInvalid';
    } else if (!_.isFinite(numericValue)) {
        props.TD.className = 'htInvalid';
    } else if (typeof min === 'number' && numericValue < min) {
        props.TD.className = 'htInvalid';
    } else if (typeof max === 'number' && numericValue > max) {
        props.TD.className = 'htInvalid';
    } else {
        props.TD.className = '';
    }

    return <div>{props.value}</div>;
};
